import {
  LOAD_INBOX_MESSAGES,
  LOAD_INBOX_MESSAGES_FAILED,
  LOAD_INBOX_MESSAGES_SUCCESS,
  GET_INBOX_CHAT_USERS,
  GET_INBOX_CHAT_USERS_FAILED,
  GET_INBOX_CHAT_USERS_SUCCESS,
  GET_INBOX_MESSAGES,
  GET_INBOX_MESSAGES_FAILED,
  GET_INBOX_MESSAGES_SUCCESS,
  INBOX_DISCONNECT,
  INCREMENT_UNREAD_MESSAGE_COUNT,
  INIT_INBOX_SESSION,
  INIT_INBOX_SESSION_FAILED,
  INIT_INBOX_SESSION_SUCCESS,
  RESET_UNREAD_MESSAGE_COUNTER,
  SAVE_COMMENT_BOARD_DIALOGS,
  SAVE_DIRECT_MESSAGE_DIALOGS,
  SAVE_DIRECT_MESSAGE_USERS,
  SAVE_NEWS_FEED_DIALOGS,
  SAVE_NEW_INBOX_MESSAGE,
  GET_MESSAGE_LIKES,
  GET_MESSAGE_LIKES_SUCCESS,
  GET_MESSAGE_LIKES_FAILED,
  UPDATE_MESSAGE_LIKES,
  UPDATE_MESSAGE_LIKES_SUCCESS,
  UPDATE_MESSAGE_LIKES_FAILED,
  SEND_PM_CHAT_NOTIFICATION,
  SEND_INBOX_MESSAGE,
  SEND_INBOX_MESSAGE_SUCCESS,
  SEND_INBOX_MESSAGE_FAILED,
} from "./actionTypes"

export const initInboxSession = params => ({
  type: INIT_INBOX_SESSION,
  payload: params,
})

export const initInboxSessionSuccess = response => ({
  type: INIT_INBOX_SESSION_SUCCESS,
  payload: response,
})

export const initInboxSessionFailed = error => ({
  type: INIT_INBOX_SESSION_FAILED,
  payload: error,
})

export const saveCommentBoardDialogs = params => ({
  type: SAVE_COMMENT_BOARD_DIALOGS,
  payload: params,
})

export const saveDirectMessageDialogs = params => ({
  type: SAVE_DIRECT_MESSAGE_DIALOGS,
  payload: params,
})

export const saveNewsFeedDialogs = params => ({
  type: SAVE_NEWS_FEED_DIALOGS,
  payload: params,
})

export const saveDirectMessageUsers = params => ({
  type: SAVE_DIRECT_MESSAGE_USERS,
  payload: params,
})

export const getInboxMessages = params => ({
  type: GET_INBOX_MESSAGES,
  payload: params,
})

export const getInboxMessagesSuccess = response => ({
  type: GET_INBOX_MESSAGES_SUCCESS,
  payload: response,
})

export const getInboxMessagesFailed = error => ({
  type: GET_INBOX_MESSAGES_FAILED,
  payload: error,
})

export const inboxDisconnect = () => ({
  type: INBOX_DISCONNECT,
})

export const resetUnreadMessageCounter = params => ({
  type: RESET_UNREAD_MESSAGE_COUNTER,
  payload: params,
})

export const incrementUnreadMessageCount = params => ({
  type: INCREMENT_UNREAD_MESSAGE_COUNT,
  payload: params,
})

export const getInboxChatUsers = params => ({
  type: GET_INBOX_CHAT_USERS,
  payload: params,
})

export const getInboxChatUsersSuccess = response => ({
  type: GET_INBOX_CHAT_USERS_SUCCESS,
  payload: response,
})

export const getInboxChatUsersFailed = error => ({
  type: GET_INBOX_CHAT_USERS_FAILED,
  payload: error,
})

export const loadInboxMessages = params => ({
  type: LOAD_INBOX_MESSAGES,
  payload: params,
})

export const loadInboxMessagesSuccess = response => ({
  type: LOAD_INBOX_MESSAGES_SUCCESS,
  payload: response,
})

export const loadInboxMessagesFailed = error => ({
  type: LOAD_INBOX_MESSAGES_FAILED,
  payload: error,
})

export const saveNewInboxMessage = params => ({
  type: SAVE_NEW_INBOX_MESSAGE,
  payload: params,
})

export const getMessageLikes = params => ({
  type: GET_MESSAGE_LIKES,
  payload: params,
})

export const getMessageLikesSuccess = response => ({
  type: GET_MESSAGE_LIKES_SUCCESS,
  payload: response,
})

export const getMessageLikesFailed = error => ({
  type: GET_MESSAGE_LIKES_FAILED,
  payload: error,
})

export const updateMessageLikes = params => ({
  type: UPDATE_MESSAGE_LIKES,
  payload: params,
})

export const updateMessageLikesSuccess = response => ({
  type: UPDATE_MESSAGE_LIKES_SUCCESS,
  payload: response,
})

export const updateMessageLikesFailed = error => ({
  type: UPDATE_MESSAGE_LIKES_FAILED,
  payload: error,
})

export const sendPmChatNotification = params => ({
  type: SEND_PM_CHAT_NOTIFICATION,
  payload: params,
})

export const sendInboxMessage = params => ({
  type: SEND_INBOX_MESSAGE,
  payload: params,
})

export const sendInboxMessageSuccess = response => ({
  type: SEND_INBOX_MESSAGE_SUCCESS,
  payload: response,
})

export const sendInboxMessageFailed = error => ({
  type: SEND_INBOX_MESSAGE_FAILED,
  payload: error,
})
